import * as types from '../mutations-types'

const layout = {
  state: {
  },
  mutations: {
    [types.SET_TABS] (state, tabs) {
      state.tabs = tabs
    },
    [types.SET_CURRENTTABVALUE] (state, currentTabValue) {
      state.currentTabValue = currentTabValue
    }
  },
  actions: {
    updatedTabs ({commit, state}, { list, name }) {
      commit(types.SET_TABS, list)
      commit(types.SET_CURRENTTABVALUE, name)
    }
  }
}
export default layout



// WEBPACK FOOTER //
// ./src/store/modules/layout.js